module.exports = __webpack_public_path__ + "img/step8.b44c8a39.png";